import { useDispatch, useSelector } from "react-redux";
import { types } from "./reducer";
import * as actions from "../Carts/actions";

export function useAuth() {
  const dispatch = useDispatch();

  const { auth } = useSelector((state) => ({
    auth: state.auth,
  }));

  const methods = {
    logout: () => {
      localStorage.clear();
      dispatch({ type: types.LOGOUT_SUCCESS });
      dispatch({ type: actions.REMOVE_ALL_CART });
    },
    isRoleClient: () => {
      return auth?.user?.role === "CLIENT";
    },
    isRoleOperator: () => {
      return auth?.user?.role === "VRP";
    },
  };

  return [auth, methods];
}
